<script>
import DataProvider from './DataProvider.vue';
import KindergartenHolidayRepository from '../../js/repository/KindergartenHolidayRepository';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        kindergartenId: {
            type: Number,
            required: true,
        },
        year: {
            type: Number,
            required: false,
            default: null,
        },
        callback: {
            type: Function,
            required: false,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: KindergartenHolidayRepository.findByKindergartenAndYear,
                params: [this.kindergartenId, this.year],
                callback: this.callback,
                reload: this.load,
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
